import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";


const Loading = props => {

  return (
    <>
			<div id="cover-spin"></div>
    </>
  );
};

export default Loading;
